import React from 'react';
import { Badge, Layout } from '@axiom/ui';
import type {
  CandidateEngagement,
  CandidateEngagementDetails,
} from '@axiom/validation';

import { EngagementsUtil } from '../../utils/engagements-util';

export type EngagementBadgesProps = {
  engagement: CandidateEngagement | CandidateEngagementDetails;
  name?: string;
};

export const EngagementBadges: React.FC<EngagementBadgesProps> = ({
  engagement,
  name = 'ENGAGEMENT_BADGES',
}) => {
  const badges = EngagementsUtil.getBadgeConfig({ engagement });

  if (badges.length === 0) {
    return null;
  }

  return (
    <Layout name={name} wrap horizontalGutter="8px" verticalGutter="8px">
      {badges.map((badgeConfig, index) => (
        <Badge
          key={badgeConfig.badge}
          name={`BADGE_${index}`}
          background={badgeConfig.color}
        >
          {badgeConfig.label}
        </Badge>
      ))}
    </Layout>
  );
};
